<template>
	<div class="measure-blood-saturation">
		<div class="date-time">
			<span class="date">{{ date(value.datetime) }}</span>
			<span class="time">{{ time(value.datetime) }}</span>
		</div>
		<d3-blood-saturation :value="value.values.last"/>
	</div>
</template>

<script>
import D3BloodSaturation from './D3BloodSaturation'
export default {
	components: {
		D3BloodSaturation
	},
	props: [
		'value'
	],
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/MeasureBloodSaturation.vue